module.exports = __webpack_public_path__ + "media/app/assets/races/mag'har_orc_female-5f84335a05042ecb4df3ed0accfc8e91.png";